<div class="d-flex flex-column w-100 w-sm-60 mx-auto">
    <div class="d-flex flex-column w-100 py-5">
        <div class="d-flex flex-column w-100 mx-auto mt-4ee p-2e">
            <p class="d-flex mx-auto mb-auto mat-headline-5 fw-bold text-center">Logged in as</p>
            <mat-divider class="d-flex my-3"></mat-divider>
            <div *ngIf="userDetails; else loadingDetails" class="d-flex flex-column w-100">
              <div class="d-flex">
                <img [src]="userDetails.photoUrl" class="d-flex w-96px h-96px mx-auto mb-3 rounded-circle" alt="Your Image">
              </div>
              <p class="mx-auto mb-auto mat-headline-5 fw-bold text-center" style="word-break: break-word;">{{ userDetails.name }}</p>
              <p class="mx-auto mb-auto mat-headline-5 fw-bold text-center" style="word-break: break-word;">{{ userDetails.email || userDetails.phoneNumber }}</p>
            </div>

            <ng-template #loadingDetails>
                <span class="mx-auto">loading...</span>
            </ng-template>
        </div>

        <!-- INFO Input Product Name -->
        <button mat-flat-button class="mt-4 px-3 py-4 fw-bold rounded-3e" color="primary" (click)="goToDestination()">
            <span class="my-auto mat-body-1 fw-bold">Continue to {{ productName }}</span>
        </button>
    </div>
</div>
